
import { computed } from '@nuxtjs/composition-api'
import { ERROR_CODE } from '@/constants/ErrorCodes'

export default {
  props: {
    errorCode: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const actionButtonClicked = (event) => {
      event.preventDefault();
      const mitTelmoreLoginUrl = `${window.location.origin}/mit-telmore/abonnement`;
      window.open(mitTelmoreLoginUrl, '_blank');
    }

    const isWithFad = computed(() => props.errorCode === ERROR_CODE.MULTIPLE_BINDING_WITH_FAD)

    return {
      actionButtonClicked,
      isWithFad
    }
  }
}
